import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { GlobalConclusionResult } from '../../../../shared/types/licenses';

export const getQueryKey = (revisionLocator: string) => ['global-conclusions', revisionLocator];

export const getGlobalConclusions = async (revisionLocator: string) => {
  return get<GlobalConclusionResult>(`/api/v2/revisions/${nuc(revisionLocator)}/correction/global-conclusions`);
};

/**
 * Hook to fetch the global and base conclusions for a revision.
 * @param revisionLocator - The locator of the revision.
 * @returns The global conclusions.
 */
export default function useGetGlobalConclusions(revisionLocator: string) {
  return useQuery({
    queryKey: getQueryKey(revisionLocator),
    queryFn: () => getGlobalConclusions(revisionLocator),
  });
}
